<template>
  <Page :response="response">
    <div class="welcome px-i">
      <div class="welcome-wrapper container-fluid">
        <div class="card welcome-wrapper-card mb-4">
          <div class="welcome-wrapper-card-header px-i">
            <h2>
              Receive Invoices
            </h2>
          </div>
          <div class="welcome-wrapper-card-body card-body px-i">
            You have not received any invoices.
          </div>
          <div class="welcome-wrapper-card-footer px-i">
            <h3>
              Merchants can now invoice you on <span class="text-primary">{{ primaryEmail }}</span>
            </h3>
          </div>
        </div>
        <div class="card welcome-wrapper-card">
          <div class="welcome-wrapper-card-header px-i">
            <h2>
              Invoice your Customers
            </h2>
          </div>
          <div class="welcome-wrapper-card-row px-i">
            <router-link :to="company.id ? `/merchant/${company.id}/profile` : `/merchant/profile/new`"
                         class="welcome-wrapper-card-row-link"
                         :class="textClass(1)"
                         @click.native="beginSetup">
              <i class="demo-icon icon-circle-1" />
              Create a Merchant Profile
            </router-link>
          </div>
          <div class="welcome-wrapper-card-row px-i">
            <router-link v-if="setupStageCheck(2)"
                         :to="`/merchant/${company.id}/account`"
                         class="welcome-wrapper-card-row-link"
                         :class="textClass(2)">
              <i class="demo-icon icon-circle-2" />
              Create a Merchant Account
            </router-link>
            <span v-else class="welcome-wrapper-card-row-text">
              <i class="demo-icon" :class="circleClass(2)" />
              Create a Merchant Account
            </span>
          </div>
          <div class="welcome-wrapper-card-row px-i">
            <router-link v-if="setupStageCheck(3)"
                         to="/templates/new"
                         class="welcome-wrapper-card-row-link"
                         :class="textClass(3)">
              <i class="demo-icon icon-circle-3" />
              Create a Template
            </router-link>
            <span v-else class="welcome-wrapper-card-row-text">
              <i class="demo-icon" :class="circleClass(3)" />
              Create a Template
            </span>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>

import WelcomeMixin from "./WelcomeMixin";
import UserStore from "../../../user_dashboard/components/User/UserStore";
import CompanyStore from "../../../shared/components/Company/CompanyStore";
import SetupStore from "../../../shared/components/Setup/SetupStore";

export default {
  name: "Welcome",

  title () {
    return `Welcome to ${Dashboard.currentTenant.name}`;
  },

  mixins: [WelcomeMixin],

  data () {
    return {
      response: { status: 200 },
      companyStoreState: CompanyStore.state,
      userStoreState: UserStore.state,
      setupStoreState: SetupStore.state
    };
  },

  computed: {
    company () {
      return this.companyStoreState.company;
    },

    user () {
      return this.userStoreState.user;
    },

    setupStage () {
      return this.setupStoreState.stage;
    },

    primaryEmail () {
      return this.user.user_emails[0].email;
    }
  },

  methods: {
    textClass (step) {
      if (this.setupStage > step) {
        return "welcome-wrapper-card-row-link-success";
      } else {
        return "";
      }
    },

    circleClass (step) {
      if (this.setupStage > step) {
        return "icon-circle-check";
      } else {
        return `icon-circle-${step}`;
      }
    },

    beginSetup () {
      SetupStore.beginSetup();
    },

    setupStageCheck (step) {
      return this.setupStage >= step;
    }
  }
};
</script>
